import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import { LEARN_MORE_BUTTON_LABEL } from '../../../constants'
import Media from 'components/common/Media'
import Link from 'components/common/Link/Link'
import { generateSliderImg } from './helpers'

const EducationalMaterialsItem = ({
  item: {
    title,
    articleDescription,
    iconName,
    articleUrl,
    screenReaderCTA
  },
  itemNumber,
  totalItemsCount
}) =>
  <Item className="educational-materials-item">
    <ItemNumber>{ `${itemNumber}/${totalItemsCount}` }</ItemNumber>

    <Wrapper>
      <ItemIcon src={ generateSliderImg(iconName) } alt={ title } />
      <Title>{ title }</Title>
      <Description>{ articleDescription }</Description>

      {articleUrl && (
        <LearnMoreLink to={ articleUrl } aria-label={ screenReaderCTA }>
          { LEARN_MORE_BUTTON_LABEL }
        </LearnMoreLink>)
      }
    </Wrapper>
  </Item>

EducationalMaterialsItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    articleDescription: PropTypes.string,
    iconName: PropTypes.string,
    articleUrl: PropTypes.string,
    screenReaderCTA: PropTypes.string
  }),
  itemNumber: PropTypes.number,
  totalItemsCount: PropTypes.number
}

export default EducationalMaterialsItem

const Item = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  padding: 20px 69px 30px 127px;
  background-color: ${Theme.colors.blue};
  ${Media.mobile`
    height: auto;
    min-height: 203px;
    padding: 20px 30px 30px 87px;
  `}
`

const ItemIcon = styled.img`
  position: absolute;
  left: -58px;
  top: 0;
  width: 45px;
  height: 45px;
`

const Wrapper = styled.div`
  position: relative;
`

const ItemNumber = styled.p`
  position: absolute;
  top: 8px;
  right: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 24px;
  margin: 0;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: 1%;
  font-weight: 700;
  color: ${Theme.colors.white};
  background-color: ${Theme.colors.transparent_white_count};
  border-radius: 4px;
  ${Media.mobile`
    top: 10px;
    right: 10px;
    width: 29px;
    height: 19px;
    font-size: 10px;
  `}
`

const Title = styled.h4`
  margin: 0 0 15px;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: 1%;
  font-weight: 700;
  text-transform: uppercase;
  color: ${Theme.colors.white};
  ${Media.mobile`
    margin: 0 0 6px;
    font-size: 13px;
    letter-spacing: 0;
  `}
`

const Description = styled.p`
  margin: 0 0 15px;
  color: ${Theme.colors.white};
  ${Media.mobile`
    font-size: 12px;
    letter-spacing: 0;
  `}
`

const LearnMoreLink = styled(Link)`
  font-weight: 700;
  color: ${Theme.colors.white};
  text-decoration: none;
  ${Media.mobile`
    font-size: 12px;
  `}

  ${Media.desktop`
    &:hover {
      text-decoration: underline;
    }
  `}
`
